module.exports = __webpack_public_path__ + "1.5.0-unryo/img/network.b7038a20.svg";